import type Store from '@ember-data/store';
import { addDays } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import type AnnouncementModel from 'garaje/models/announcement';

export const ANNOUNCEMENT_FIELDS = {
  announcements: 'id,created-at,title,message,statistics,creator-employee,location,takeovers',
  employees: 'id,name',
} as const;

export const ANNOUNCEMENT_INCLUDE = 'creator-employee,takeovers';

interface AnnouncementQueryParams {
  page: {
    limit: number;
    offset: number;
  };
  filter: { [key: string]: string };
  include: string;
  fields: {
    announcements: string;
    employees: string;
  };
  sort: string;
}

export function getAnnouncementQueryParams(
  locationIds?: string[],
  startDate?: Date,
  endDate?: Date,
  limit = 25,
  offset = 0,
): AnnouncementQueryParams {
  const baseParams: AnnouncementQueryParams = {
    page: { limit, offset },
    include: ANNOUNCEMENT_INCLUDE,
    filter: {
      archived: 'null',
    },
    fields: ANNOUNCEMENT_FIELDS,
    sort: '-createdAt',
  };

  if (locationIds && locationIds.length > 0) {
    baseParams.filter['location'] = locationIds?.join(',');
  }

  if (startDate && endDate) {
    const newEndDate = addDays(endDate, 1);
    baseParams.filter['datetime-from'] = formatInTimeZone(startDate, 'UTC', 'yyyy-MM-dd');
    baseParams.filter['datetime-to'] = formatInTimeZone(newEndDate, 'UTC', 'yyyy-MM-dd');
  }

  return baseParams;
}

export function fetchAnnouncementById(store: Store, id: string): Promise<AnnouncementModel> {
  return store.findRecord('announcement', id, {
    adapterOptions: { v3: true, fields: ANNOUNCEMENT_FIELDS },
    include: ANNOUNCEMENT_INCLUDE,
    reload: true,
  }) as unknown as Promise<AnnouncementModel>;
}
